module.exports = __webpack_public_path__ + "img/fotos_7.be92af56.jpg";